const profilePic = {
	'Absolute Zero': '/img/profile_AbZ.png',
	Aile: '/img/profile_aile.png',
	Alia: '/img/profile_alia.png',
	Axl: '/img/profile_axl.png',
	Bass: '/img/profile_bass.png',
	'Bass.EXE': '/img/profile_BEXE.png',
	'Bass GS': '/img/profile_BGS.png',
	Bit: '/img/profile_bit.png',
	'Black Zero': '/img/profile_BZ.png',
	Ciel: '/img/profile_ciel.png',
	Cinnamon: '/img/profile_cinnamon.png',
	Colonel: '/img/profile_colonel.png',
	'Copy X': '/img/profile_copyX.png',
	'Dark MegaMan.EXE': '/img/profile_DMMEXE.png',
	Dynamo: '/img/profile_dynamo.png',
	'Falcon Armor X': '/img/profile_falcon.png',
	Ferham: '/img/profile_ferham.png',
	'First Armor X': '/img/profile_fax.png',
	Harpuia: '/img/profile_harp.png',
	Iris: '/img/profile_iris.png',
	Layer: '/img/profile_layer.png',
	Leviathan: '/img/profile_leviathan.png',
	'Magma Dragoon': '/img/profile_dragoon.png',
	Marino: '/img/profile_marino.png',
	Massimo: '/img/profile_massimo.png',
	'Mega Man': '/img/profile_MM.png',
	'MegaMan.EXE': '/img/profile_MMEXE.png',
	'MegaMan Volnutt': '/img/profile_volnutt.png',
	Omega: '/img/profile_omega.png',
	Pallette: '/img/profile_pallette.png',
	Pandora: '/img/profile_pandora.png',
	'Proto Man': '/img/profile_PM.png',
	Roll: '/img/profile_roll.png',
	'Roll Caskett': '/img/profile_rollCask.png',
	'Second Armor X': '/img/profile_SAX.png',
	Sigma: '/img/profile_SigmaX1.png',
	'Sigma (X4 2nd form)': '/img/profile_sigmaX4.png',
	'Super Mega Man': '/img/profile_SMM.png',
	'Third Armor X': '/img/profile_TAX.png',
	'Tron Bonne': '/img/profile_TronBonne.png',
	'Ultimate Armor X': '/img/profile_UAX.png',
	'Ultimate Armor X (CM)': '/img/profile_UCM.png',
	Vile: '/img/profile_vile.png',
	'Vile MK-II': '/img/profile_vileMK2.png',
	X: '/img/profile_x.png',
	Zero: '/img/profile_zero.png',
	'Zero(Z)': '/img/profile_MMZ.png'
};

const icons = {
	'Absolute Zero': '/a/a9/Absolute_Zero_Mug.png',
	Aile: '/1/16/Aile_Mug.png',
	Alia: '/4/46/Alia_mug.png',
	Axl: '/f/f8/Axl_mug.png',
	Bass: '/9/92/Bass_Mug.png',
	'Bass.EXE': '/7/7b/Bassexe_Mug.png',
	'Bass GS': '/3/31/Bass_GS_Mug.png',
	Bit: '/e/e4/Bit_Playable_Mug.png',
	// Black zero
	Ciel: '/e/e8/Ciel_mug.png',
	Cinnamon: '/a/a1/Cinnamon_mug.png',
	Colonel: '/5/5a/Colonel_Mug.png',
	'Copy X': '/3/3d/Copy_x_mug.png',
	'Dark MegaMan.EXE': '/6/6e/Dark_MegaMan.EXE_Mug.png',
	Dynamo: '/1/15/Dynamo_Mug.png',
	'Falcon Armor X': '/a/a8/Falcon_Armor_X_Mug.png',
	Ferham: '/6/6a/Ferham_mug.png',
	'First Armor X': '/3/30/First_Armor_X_mug.png',
	Harpuia: '/3/33/Harpuia_Mug.png',
	Iris: '/9/96/Iris_mug.png',
	Layer: '/6/63/Layer_mug.png',
	Leviathan: '/3/3a/Leviathan_Mug.png',
	'Magma Dragoon': '/7/7b/Magma_Dragoon_Playable_Mug.png',
	Marino: '/0/03/Marino_mug.png',
	Massimo: '/2/22/Massimo_mug.png',
	'Mega Man': '/d/da/Mega_man_mug.png',
	'MegaMan.EXE': '/8/83/Megamanexe_mug.png',
	'MegaMan Volnutt': '/4/46/MegaMan_Volnutt_Mug.png',
	Omega: '/d/d3/Omega_Mug.png',
	Pallette: '/f/ff/Pallette_mug.png',
	Pandora: '/a/a6/Pandora_Mug.png',
	'Proto Man': '/3/38/Protoman_mug.png',
	Roll: '/9/95/Roll_mug.png',
	'Roll Caskett': '/5/5e/Roll_Caskett_Mug.png',
	'Second Armor X': '/6/67/Second_armor_x_mug.png',
	Sigma: '/c/c0/Sigma_mug.png',
	'Sigma (X4 2nd form)': '/b/b5/Sigma_%28X4_2nd_form%29_Mug.png',
	'Super Mega Man': '/8/81/Super_mega_man_mug.png',
	'Third Armor X': '/4/44/Third_Armor_X_Mug.png',
	'Tron Bonne': '/1/12/Tron_Bonne_Mug.png',
	'Ultimate Armor X': '/a/a4/Ultimate_armor_X_mug.png',
	'Ultimate Armor X (CM)': '/1/14/Ultimate_Armor_X_%28CM%29_mug.png',
	Vile: '/9/95/Vile_mug.png',
	'Vile MK-II': '/4/49/Vile_MK-II_Mug.png',
	X: '/7/77/X_mug.png',
	Zero: '/d/df/Zero_mug.png',
	'Zero(Z)': '/e/e9/MMZ_Zero_Mug.png'
};
export {
	profilePic,
	icons
};
